import serializeArray from './serializeArray';

// ----------------------------------------------------------------------------

function serialize(form: HTMLFormElement): string {
    const entries = serializeArray(form);
    const params = new URLSearchParams();

    for (const { name, value } of entries) {
        params.append(name, value);
    }

    return params.toString();
}

// ----------------------------------------------------------------------------

export default serialize;
